module.exports = "/images/search_beauty.svg?8b03f4634dbf7daa8548855a1379f0c6";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icons/search_beauty.svg
// module id = 2zp7
// module chunks = 0